// src/lib/title-service/title-service.ts
import { useEffect } from "react";
var useTitleService = (title) => {
  useEffect(() => {
    document.title = title;
  }, []);
};

// src/lib/formatting/address-formatting.ts
var AddressLineFormatter = (addressLine) => {
  return addressLine != "" ? ", " + addressLine : "";
};

// src/lib/enum-description/enum-description.ts
function getEnumKeyByEnumValue(myEnum, enumValue) {
  let longDesc = "No Match";
  Object.keys(myEnum).forEach((key) => {
    if (key == enumValue)
      longDesc = myEnum[key];
  });
  return longDesc;
}

// src/lib/caseref-transform/caseref-transform.ts
var caseRefReplaceSlashWithDash = (caseRef) => {
  return caseRef.replace(/\//g, "-");
};

// src/lib/document-api-url/document-api-url.ts
var constructDocumentApiUrl = (baseApi, caseRefDashes, documentId) => {
  return baseApi + "appeals/" + caseRefDashes + "/documents/" + documentId;
};

// src/lib/formatting/date-formatting.ts
var standardDateFormatter = (dateToFormat) => {
  return dateToFormat.toLocaleString("en-GB", {
    year: "numeric",
    month: "long",
    day: "numeric"
  });
};
var longDateFormatter = (dateToFormat) => {
  return dateToFormat.toLocaleString("en-GB", {
    hour: "numeric",
    minute: "numeric",
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric"
  });
};

// src/lib/caseref-transform/caseref-formatting.ts
var caseRefSplit = (caseref) => {
  const arr = caseref.split("/");
  let newStr = "";
  if (arr.length < 3) {
    return caseref;
  }
  arr.forEach((str, index) => {
    newStr += str;
    if (index !== arr.length - 1) {
      if (index === 2) {
        newStr += "/ ";
      } else {
        newStr += "/";
      }
    }
  });
  return newStr;
};

// src/lib/bloblink-transform/bloblink-transform.ts
var replaceDevLinkWithConfig = (fdString, saString, linkToReplace) => {
  if (fdString.length === 0) {
    return linkToReplace.replace("ltcdvstrauks003", saString);
  } else {
    return linkToReplace.replace(
      "https://ltcdvstrauks003.blob.core.windows.net/",
      fdString
    );
  }
};

// src/lib/data-access/config-loader.ts
import axios from "axios";
import { useQuery } from "react-query";
var useConfigLoader = () => {
  const fetchData = async () => {
    const { data } = await axios.get("/config.json");
    return data;
  };
  return useQuery("appConfig", fetchData);
};

// src/lib/data-access/download-query.ts
import axios2 from "axios";
var downloadQuery = (props) => {
  return axios2.get(props.apiUrl, {
    responseType: "blob",
    headers: {
      Authorization: "Bearer " + props.token
    }
  });
};

// src/lib/data-access/useDownload.ts
import { useRef, useState } from "react";
var useDownloadFile = (downloadFileProps) => {
  const ref = useRef(null);
  const [url, setFileUrl] = useState();
  const [name, setFileName] = useState();
  const download = async () => {
    try {
      downloadFileProps.preDownloading();
      const { data } = await downloadFileProps.apiDefinition({
        apiUrl: downloadFileProps.apiUrl,
        token: downloadFileProps.token
      });
      const url2 = URL.createObjectURL(new Blob([data]));
      setFileUrl(url2);
      setFileName(downloadFileProps.fileName);
      setTimeout(() => {
        ref.current?.click();
        downloadFileProps.postDownloading();
        URL.revokeObjectURL(url2);
      }, 100);
    } catch (error) {
      downloadFileProps.onError();
    }
  };
  return { download, ref, url, name };
};
export {
  AddressLineFormatter,
  caseRefReplaceSlashWithDash,
  caseRefSplit,
  constructDocumentApiUrl,
  downloadQuery,
  getEnumKeyByEnumValue,
  longDateFormatter,
  replaceDevLinkWithConfig,
  standardDateFormatter,
  useConfigLoader,
  useDownloadFile,
  useTitleService
};
